import React, { useEffect, useRef, useState } from 'react';

const CardboardBox3D = ({ isOpen = false, isDragging = false, className = '', imageSrc = null }) => {
  const canvasRef = useRef(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const currentSrc = imageSrc || '/box.jpg';

  useEffect(() => {
    setImageLoaded(false);
    setImageError(false);
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.crossOrigin = 'anonymous';
    
    // Clear canvas first to avoid showing old content
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    img.onload = () => {
      // Double check canvas is still mounted
      if (!canvasRef.current) return;
      
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      
      // Supprimer le fond noir
      try {
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;
        
        for (let i = 0; i < data.length; i += 4) {
          if (data[i] < 30 && data[i + 1] < 30 && data[i + 2] < 30) {
            data[i + 3] = 0;
          }
        }
        
        ctx.putImageData(imageData, 0, 0);
        setImageLoaded(true);
      } catch (e) {
        // CORS or other error - show image as-is
        console.warn('Canvas processing error:', e);
        setImageLoaded(true);
      }
    };
    
    img.onerror = () => {
      console.error('Failed to load box image');
      setImageError(true);
    };
    
    // Add cache busting only if loading fails
    img.src = currentSrc;
    
    return () => {
      // Cleanup
      img.onload = null;
      img.onerror = null;
    };
  }, [currentSrc]);

  // Fallback to regular img if canvas fails
  if (imageError) {
    return (
      <div className={`relative flex items-center justify-center ${className}`} style={{ minHeight: '200px', marginTop: '-40px' }}>
        <img 
          src={currentSrc} 
          alt="Box" 
          style={{ width: '280px', height: 'auto' }}
          className={`transition-transform duration-300 ${isDragging ? 'scale-110' : 'hover:scale-105'}`}
        />
      </div>
    );
  }

  return (
    <div className={`relative flex items-center justify-center ${className}`} style={{ minHeight: '200px', marginTop: '-40px' }}>
      <div className="relative">
        <canvas
          ref={canvasRef}
          className={`transition-transform duration-300 ${isDragging ? 'scale-110' : 'hover:scale-105'}`}
          style={{
            width: '280px',
            height: 'auto',
            opacity: imageLoaded ? 1 : 0,
            transition: 'opacity 0.3s ease'
          }}
        />
        
        {isDragging && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="animate-bounce text-cyan-400">
              <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CardboardBox3D;
